import { render, staticRenderFns } from "./additional-vendor-codes.vue?vue&type=template&id=a84c36f4&scoped=true&"
import script from "./additional-vendor-codes.vue?vue&type=script&lang=js&"
export * from "./additional-vendor-codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84c36f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
